<lms-group-log
  [listId]="groupActivityListId"
  [group]="group"
  [course]="course"
  [options]="{ hidePaginator: group.hasBonus ? true : false }"
></lms-group-log>
